import AxiosInstance from "@/components/Axios"

export async function generateQR(project_id: string) {
    const response = await AxiosInstance.post("/api/afs/generate-qr-download", { project_id })
    return response.data
}